import React from "react";
import { ArrowUpRight, Github } from "lucide-react";
import seasonal from "../assets/fruits.png";
import bzwebsite from "../assets/portfolio.png";
import nextask from "../assets/nextask.png";
import eco from "../assets/ecothreads.png";
import inmyfridge from "../assets/inmyfridge.jpg";

const ProjectItem = ({ title, desc, lang, github, link, src, index }) => {
  const isEven = index % 2 === 0;

  return (
    <div className="group border-t border-border py-20 md:grid md:grid-cols-12 gap-12 items-center">

      <div className={`md:col-span-7 mb-8 md:mb-0 ${!isEven ? 'md:order-last' : ''}`}>
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="block overflow-hidden rounded-[2rem] border border-border bg-secondary/5"
        >
          <img
            src={src}
            alt={title}
            className="w-full h-auto aspect-video object-cover transition-transform duration-1000 group-hover:scale-105"
          />
        </a>
      </div>

      <div className="md:col-span-5 flex flex-col justify-center">
        <div className="space-y-6">
          <div className="flex items-center gap-3">
            {/* <span className="text-[10px] font-bold text-secondary/40 tracking-[0.4em]">0{index + 1}</span> */}
            <div className="h-px w-8 bg-secondary opacity-50"></div>
          </div>

          <h3 className="text-4xl md:text-5xl font-bold tracking-tighter text-text lowercase">
            {title}.
          </h3>

          <p className="text-lg text-secondary font-light leading-relaxed">
            {desc}
          </p>

          <div className="flex flex-wrap gap-2">
            {lang.map((tech, i) => (
              <span key={i} className="text-[10px] uppercase tracking-widest font-bold text-secondary">
                {tech} {i !== lang.length - 1 && "•"}
              </span>
            ))}
          </div>

          <div className="flex items-center gap-6 pt-4">
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-text group/link"
            >
              View Site
              <ArrowUpRight size={16} className="transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1" />
            </a>
            {github && (
              <a
                href={github}
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary hover:text-text transition-colors"
              >
                <Github size={20} />
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const Projects = () => {
  const projects = [
    {
      title: "In My Fridge",
      desc: "a kitchen management app designed to reduce food waste by tracking real-time fridge inventory and translating ingredients into curated weekly meal plans.",
      lang: ["react.js", "supabase"],
      github: "https://github.com/billie-zhang/In-My-Fridge",
      link: "https://inmyfridge.vercel.app/",
      src: inmyfridge,
    },
    {
      title: "Seasonal",
      desc: "a smart fruit companion that scans produce to determine ripeness and seasonality, paired with AI-driven recipe recommendations.",
      lang: ["react.js", "tailwind CSS", "Google CV", "OpenAI"],
      github: "https://github.com/billie-zhang/Seasonal",
      link: "https://seasonal-app.vercel.app/",
      src: seasonal,
    },
    {
      title: "Portfolio",
      desc: "the site you're on now! a minimalist digital archive of my work in engineering and product.",
      lang: ["react.js", "tailwind CSS"],
      link: "https://billiezhang.vercel.app/",
      src: bzwebsite,
    },
    {
      title: "nexTask",
      desc: "goal-setting refactored. an application designed to decompose complex ambitions into actionable, trackable tasks.",
      lang: ["vite js", "tailwind CSS"],
      github: "https://github.com/billie-zhang/nexTask",
      link: "https://thenextask.vercel.app/",
      src: nextask,
    },
    {
      title: "EcoThreads",
      desc: "interactive fashion sustainability interface built for HackTheGlobe.",
      lang: ["react.js", "tailwind CSS", "Figma"],
      github: "https://github.com/billie-zhang/EcoThreads",
      link: "https://billie-zhang.github.io/EcoThreads/",
      src: eco,
    },
  ];

  return (
    <section id="projects" className="py-40 bg-background">
      <div className="max-w-6xl mx-auto px-6">

        <div className="mb-20">

          <h3 className="text-5xl md:text-7xl font-bold tracking-tighter text-text">
            projects.
          </h3>
        </div>

        <div className="flex flex-col">
          {projects.map((project, index) => (
            <ProjectItem key={index} index={index} {...project} />
          ))}
          <div className="border-t border-border"></div>
        </div>
      </div>
    </section>
  );
};

export default Projects;